import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getPaginationActions } from '~/shared/helpers/redux-helpers';
import { initialPageInfo } from '~/shared/store/slices/lessons/lessons-slice';
import type { UserType } from '~/types';

type LessonTemplatesType = {
  userGroupsPagination: {
    items: Record<string, unknown>[];
    isLoading: boolean;
    pageInfo: Record<string, unknown>;
  };
};

const initialState: LessonTemplatesType = {
  userGroupsPagination: {
    items: [],
    isLoading: false,
    pageInfo: initialPageInfo,
  },
};

export const userGroupsSlice = createSlice({
  name: 'userGroups',
  initialState,
  reducers: {
    setUserGroupsPagination: (state, action: PayloadAction<UserType>) => {
      state.userGroupsPagination = action.payload;
    },
    ...getPaginationActions('userGroupsPagination'),
  },
});

export const { setUserGroupsPaginationLoading, appendUserGroupsPagination, setUserGroupsPagination } =
  userGroupsSlice.actions;
